<template>
  <a target="_blank"
     :href="href"
     class="c-button c-button--shrinked tw-m-1" :class="isContract ? 'c-button--default' : 'c-button--success'">
    <font-awesome-icon class="c-button__left-icon" :icon="isContract ? ['fal', 'file-signature'] : ['fas','download']"></font-awesome-icon>
    {{ label }}
  </a>
</template>
<script>
export default {
  props: {
    href: String,
    label: String,
    isContract: Boolean,
  }
}
</script>
